import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { bindActionCreators } from 'redux';
import { sendOtp } from '../../actions/authAction';
import Input from "sushiweb/InputTypes/Input";
import Check from "sushiweb/Icons/all/Check";
import * as symbols from '../../operations/symbols';
import { validateLogin } from '../../operations/form-validation/formValidation';

class LoginComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      login: {
        fields: {
          phoneNumber: '',
        },
        errors: {
          phoneNumber: null
        }
      },
      validations: {
        phoneNumber: null,
      },
      allValidated: false
    }
  }

  handleChange(type, field, value) {
    this.setState(prevState => ({
      [type]: {
        errors: {
          ...prevState[type].errors,
        },
        fields: {
          ...prevState[type].fields,
          [field]: value
        }
      }
    }), () => {
      this.validateThisField(type, field, value);
    })
  }

  beginValidation(type, field, value) {
    this.setState(prevState => ({
      validations: {
        ...prevState.validations,
        [field]: true
      }
    }), () => {
      this.validateThisField(type, field, value);
    })
  }

  validateThisField(type, field, value) {
    var errList = validateLogin(this.state[type]);
    var err = errList[field];
    this.setState(prevState => ({
      [type]: {
        ...prevState[type],
        errors: {
          ...prevState[type].errors,
          [field]: err
        }
      },
      allValidated: errList.isValidated
    }))
  }

  onLogin(e) {
    e.preventDefault();
    let loginValidatedData = validateLogin(this.state.login);
    if (!loginValidatedData.isValidated) {
      this.setState(prevState => ({
        login: {
          ...prevState.login,
          errors: loginValidatedData
        }
      }))
    } else {
      this.setState(prevState => ({
        login: {
          ...prevState.login,
          errors: {}
        }
      }), () => {
        this.props.sendOtp(this.state.login.fields);
      })

    }
    return false;
  }

  componentDidUpdate = (prevProps) => {
    const { sendOtpStatus } = this.props;
    const prevStatuses = prevProps.sendOtpStatus;
    if (
      sendOtpStatus !== prevStatuses &&
      sendOtpStatus === symbols.STATUS_DONE
    ) {
      this.props.sendOtpDone(this.state.login.fields.phoneNumber);
    }
  }

  render() {
    return (
      <form onSubmit={(e) => this.onLogin(e)}>
        <div className="input-field-wrap">
          <Input
            label="Phone number"
            type="text"
            name="phone"
            key={'login1'}
            icon={this.state.validations.phoneNumber ? this.state.login.errors.phoneNumber ? "" : <Check /> : ""}
            iconColor="green"
            value={this.state.login.fields.phoneNumber}
            onBlur={(e) => this.beginValidation('login', 'phoneNumber', e)}
            errorMsg={this.state.validations.phoneNumber ? this.state.login.errors.phoneNumber : null}
            onChange={(e) => this.handleChange('login', 'phoneNumber', e)}
          />
        </div>
        <div className="btn-wrapper">
          <button type="submit" className={this.state.allValidated ? "btn btn-green" : "btn btn-disabled"}>
          {
            this.props.sendOtpStatus == symbols.STATUS_BEGIN ?
            'Sending...' : 'Send OTP'
          }
          </button>
        </div>
          {
            this.props.sendOtpStatus == symbols.STATUS_FAIL && <div className="mt-2 red-text">{this.props.sendOtpError && this.props.sendOtpError.error.message} </div>
          }
          {
            this.props.errors &&  this.props.errors.error ?
            <div className="error mt-1">{this.props.errors.error.message}</div> : null
          }
      </form>
    )
  }
}

export default connect(
  state => ({
    errors: state.statuses.login.errors,
    status: state.statuses.login.status,
    sendOtpStatus: state.statuses.sendOtp.status,
    sendOtpError: state.statuses.sendOtp.errors,
  }),
  dispatch => ({
    sendOtp: bindActionCreators(sendOtp, dispatch),
  }),
)(LoginComponent);
